import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const residentInvoiceList = createAsyncThunk("residentInvoice/list", async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: "GET",
            url: getConfig.API_URL + `resident_invoice`,
            params: {
                unit_id: data?.unit_id,
                year_id: data?.year_id,
                month: data?.month,
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const residentInvoiceDetails = createAsyncThunk("residentInvoice/details", async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: "GET",
            url: getConfig.API_URL + `resident_invoice/${encodeURIComponent(id)}`,
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const residentInvoice = createSlice({
    name: "residentInvoice",
    initialState: {
        list: [],
        details: null,
        loading: false,
        detailsLoading: false,
    },
    reducers: {
        clearResidentInvoiceDetails: (state) => {
            state.details = null
            state.detailsLoading = false
        },
    },
    extraReducers: (builder) => {
        builder.addCase(residentInvoiceList.pending, (state) => {
            state.loading = true
        })
        builder.addCase(residentInvoiceList.fulfilled, (state, action) => {
            state.loading = false
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data || []
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })
        builder.addCase(residentInvoiceList.rejected, (state) => {
            state.loading = false
            state.list = []
        })

        builder.addCase(residentInvoiceDetails.pending, (state) => {
            state.detailsLoading = true
        })
        builder.addCase(residentInvoiceDetails.fulfilled, (state, action) => {
            state.detailsLoading = false
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data || null
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        })
        builder.addCase(residentInvoiceDetails.rejected, (state) => {
            state.detailsLoading = false
            state.details = null
        })
    },
})

export const { clearResidentInvoiceDetails } = residentInvoice.actions
export default residentInvoice.reducer
